module.exports = __webpack_public_path__ + "static/icons/icon-upload-14cfa9b056f7fb7a98e7fe5eaedde4d6.svg";